module.exports = __webpack_public_path__ + "static/media/error404.fef1ce0b.svg";